import {Button, Tooltip} from "antd";
import Icons from "assets/icons";
import dayjs from "dayjs";
import {convertIosStringToDate, formatToCurrencyType} from "helper/common";
import React from "react";

const columnsSpecifyList2: any = [
  {
    title: "Mã phiếu chỉ định",
    dataIndex: "id",
    key: "id",
    align: "left",
  },
  {
    title: "Thời gian chỉ định",
    dataIndex: "ngayTaoPhieu",
    key: "ngayTaoPhieu",
    align: "left",
    render: (v, r, i) => convertIosStringToDate(v)?.format("HH:mm DD/MM/YYYY"),
  },
  {
    title: "Tổng số tiền",
    dataIndex: "tongTien",
    key: "tongTien",
    align: "right",
    render: (v, r, i) => formatToCurrencyType(v),
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
  },
];

export {columnsSpecifyList2};
